import api from './client'
import type { AccountAnchor, AccountNote, NotePayload, PaginatedResponse } from '../api'

function basePath(anchor: AccountAnchor): string {
  return anchor.kind === 'merchant'
    ? `/merchants/${anchor.id}/notes`
    : `/leads/${anchor.id}/notes`
}

export const notesApi = {
  list: async (anchor: AccountAnchor, page = 1): Promise<PaginatedResponse<AccountNote>> => {
    const response = await api.get<PaginatedResponse<AccountNote>>(basePath(anchor), {
      params: { page },
    })
    return response.data
  },

  create: async (anchor: AccountAnchor, payload: NotePayload): Promise<AccountNote> => {
    const response = await api.post<AccountNote>(basePath(anchor), payload)
    return response.data
  },

  delete: async (noteId: string): Promise<void> => {
    await api.delete(`/notes/${noteId}`)
  },
}
